import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ConfigurationI18nContext } from "./ConfigurationI18nContext";
import { TranslationNamespace } from "./TranslationNamespace";
import { useCimodeLocaleOverride } from "./useCimodeLocaleOverride";
/**
 * Provides translator for custom translations
 *
 * Notes
 * - uses the configuration language
 *
 * @category Translation
 * @returns
 */
export function useCustomTranslation() {
    const i18n = useContext(ConfigurationI18nContext);
    const lng = useCimodeLocaleOverride(i18n);
    return useTranslation(TranslationNamespace.Configuration, { i18n, lng });
}
//# sourceMappingURL=useCustomTranslation.js.map